module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "template template--basic"
  }, [_c('div', {
    staticClass: "login"
  }, [_c('header', {
    staticClass: "login__header"
  }, [_c('h1', [_vm._v("Welkom terug!")]), _c('p', [_vm._v("Vul je e-mailadres en wachtwoord in om je werkmap te openen\n                "), (_vm.otherLinks) ? [_c('br'), _c('strong', [_vm._v("Nog geen werkmap?")]), _vm._v(" Ga naar "), _c('router-link', {
    staticClass: "to-register",
    attrs: {
      "to": {
        name: 'register'
      }
    }
  }, [_vm._v("registreren")])] : _vm._e()], 2)]), _c('div', {
    staticClass: "login__panel-wrap"
  }, [_c('div', {
    staticClass: "login__panel"
  }, [_c('form', {
    staticClass: "login__form"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("E-mail")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "email",
      "name": "email",
      "id": "email",
      "autofocus": !_vm.isTouch
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Wachtwoord")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "name": "password",
      "id": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remember),
      expression: "remember"
    }],
    attrs: {
      "type": "checkbox",
      "name": "remember",
      "id": "remember"
    },
    domProps: {
      "checked": Array.isArray(_vm.remember) ? _vm._i(_vm.remember, null) > -1 : (_vm.remember)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.remember,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.remember = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.remember = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.remember = $$c
        }
      }
    }
  }), _c('label', {
    attrs: {
      "for": "remember"
    }
  }, [_vm._v("Blijf 30 dagen ingelogd")])]), _c('primary-button', {
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "clicked": _vm.submit
    }
  }, [_vm._v("Inloggen")])], 1)]), (_vm.otherLinks) ? _c('div', {
    staticClass: "login__auth-other",
    class: {
      'auth-attention': _vm.hasInvalidCredentials
    }
  }, [_c('router-link', {
    staticClass: "to-register",
    attrs: {
      "to": {
        name: 'register'
      }
    }
  }, [_vm._v("Registreren")]), _vm._v(" |\n                "), _c('router-link', {
    staticClass: "to-forgot-password",
    attrs: {
      "to": {
        name: 'forgot'
      }
    }
  }, [_vm._v("Wachtwoord vergeten")])], 1) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bc76db1a","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/auth/Login.vue
// module id = UE1J
// module chunks = 0 1